/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbFeuillePresenceGridDto } from './FcbFeuillePresenceGridDto';
import {
    FcbFeuillePresenceGridDtoFromJSON,
    FcbFeuillePresenceGridDtoFromJSONTyped,
    FcbFeuillePresenceGridDtoToJSON,
} from './FcbFeuillePresenceGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbFeuillePresenceGridDtoPaginatedResults
 */
export interface FcbFeuillePresenceGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbFeuillePresenceGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbFeuillePresenceGridDto>}
     * @memberof FcbFeuillePresenceGridDtoPaginatedResults
     */
    results?: Array<FcbFeuillePresenceGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbFeuillePresenceGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbFeuillePresenceGridDtoPaginatedResults interface.
 */
export function instanceOfFcbFeuillePresenceGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbFeuillePresenceGridDtoPaginatedResultsFromJSON(json: any): FcbFeuillePresenceGridDtoPaginatedResults {
    return FcbFeuillePresenceGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbFeuillePresenceGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbFeuillePresenceGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbFeuillePresenceGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbFeuillePresenceGridDtoPaginatedResultsToJSON(value?: FcbFeuillePresenceGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbFeuillePresenceGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

